import { formatDateEnLocale } from '@zorro/shared/formatters';

/**
 * The one date line a document card shows, on every surface. Product decision
 * (2026-08-19): the creation date — stable, so a rename or re-share never
 * shifts what the card says.
 */
export const buildDocumentCardDate = (createdAt: string): string =>
  `Created on ${formatDateEnLocale(createdAt)}`;
